import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RestAPIService } from './services/restapi.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(private translate: TranslateService, public restAPIService: RestAPIService) {
    translate.setDefaultLang('en'); // Set default language
  }
  
  title = 'sl-video-web';
}
